import React, { useCallback, useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import ContentWrapper from "../../components/contentwrapper/ContentWrapper";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import JoditEditor from "jodit-react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { FaRegHandPointRight } from "react-icons/fa";
import moment from "moment";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { addFormData, fetchAllDataByIDAPI, getSingleDataFromDataBase } from "../../utils/api";

const TicketDetails = () => {
    const editor = useRef(null);
    const { slug } = useParams();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const hrdata = localStorage.getItem("hrdata");
    const hruniqueid = localStorage.getItem("hruniqueid")
    const [ticketreply, setTicketReply] = useState([]);
    const [tdetail, setTicketDetails] = useState([]);
    const [values, setValues] = useState({
        ticket_reply_status: "",
        ticket_desc: "",
    });
    const [validated, setValidated] = useState(false);

    const statuses = [
        "Holding", "Prioritized", "Pending", "In Progress", "On Hold",
        "Under Review", "Approved", "Completed", "Cancelled",
        "Failed", "Reopened", "Escalated", "On Going",
        "Deferred", "Resolved"
    ];

    useEffect(() => {
        if (hrdata) {
            getTicketDetails(slug);
            fetchTicketReplies();
        } else {
            navigate("/");
        }
    }, [hrdata, slug]);

    const fetchTicketReplies = useCallback(() => {
        setIsLoading(true);
        fetchAllDataByIDAPI(`ticket-get-all-ticket-reply/${slug}`)
            .then((res) => {
                if (res.data.status === 1) {
                    setTicketReply(res.data.replydata || []);
                } else {
                    setTicketReply([]);
                }
            })
            .catch(() => {
                toast.error("Error fetching ticket replies.");
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [slug]);
    const getTicketDetails = (slug) => {
        fetchAllDataByIDAPI(`ticket-get-ticket-details/${slug}`).then((res) => {
            if (res.data.status === 1) {
                setTicketDetails(res.data.tdetails || []);
            } else {
                setTicketReply([]);
            }
        })
    }

    const handleReplyTask = async (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.stopPropagation();
            setValidated(true);
            return;
        }

        const replyData = {
            ticket_id: slug,
            ticket_replyer_id: hruniqueid,
            ticket_reply_status: values.ticket_reply_status,
            ticket_reply_desc: values.ticket_desc,
        };
        try {
            const res = await addFormData(`ticket-add-reply-ticket`, replyData);
            if (res.data.status === 1) {
                fetchTicketReplies();
                toast.success("Reply has been added successfully!");
                setValues({ ticket_reply_status: "", ticket_desc: "" });
            } else {
                toast.warning("Check your connection!");
            }
        } catch (error) {
            toast.error("Error adding reply.");
        }
    };

    const handleInputs = (e) => {
        const { name, value } = e.target;
        setValues({ ...values, [name]: value });
    };

    const contentFieldChange = (data) => {
        setValues({ ...values, ticket_desc: data });
    };

    const getBackgroundColor = (name) => {
        if (!name || typeof name !== "string") {
            return "#ccc";
        }

        let hash = 0;
        for (let i = 0; i < name.length; i++) {
            hash = name.charCodeAt(i) + ((hash << 5) - hash);
        }
        const color = `hsl(${hash % 360}, 50%, 70%)`;
        return color;
    };

    return (
        <div className="misDashboard">
            <Helmet>
                <title>SATKARTAR: TICKET DETAILS</title>
            </Helmet>
            <ContentWrapper>
                <div className="card p-2 marbottom">
                    <Form noValidate validated={validated} method="post" onSubmit={handleReplyTask}>
                        <Row className="mb-3">
                            <Form.Group as={Col} md="12" controlId="validationCustom05">
                                <Form.Label>Select Status</Form.Label>
                                <Form.Select
                                    required
                                    name="ticket_reply_status"
                                    value={values.ticket_reply_status}
                                    onChange={handleInputs}
                                >
                                    <option value="">Select Status</option>
                                    {statuses.map((status) => (
                                        <option key={status} value={status}>
                                            {status}
                                        </option>
                                    ))}
                                </Form.Select>
                                <Form.Control.Feedback type="invalid">
                                    <FaRegHandPointRight /> Please select a valid status.
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group as={Col} md="12" controlId="validationCustom07" className="mt-2 mb-2">
                                <Form.Label>Description</Form.Label>
                                <JoditEditor
                                    ref={editor}
                                    value={values.ticket_desc}
                                    onChange={contentFieldChange}
                                />
                            </Form.Group>
                            <Button
                                type="submit"
                                className="btn btn-sm btn-primary rounded d-flex m-auto mt-2"
                                style={{ width: "10%", justifyContent: "center", fontSize:"15px",padding:"3px 10px" }}
                            >
                                Submit
                            </Button>
                        </Row>
                    </Form>
                    <span className="hrline"></span>
                    <div className="commit-list-card">
                        <div className="d-flex justify-content-between">
                        <h4 className="text-left titckettitle">{tdetail?.ticket_title}<span style={{color:"green"}}>({tdetail?.ticket_priority})</span></h4>
                            <div className="d-flex" style={{ gap: "5px" }}>
                                <span style={{margin:"Auto"}} className="tagnames">
                                    {tdetail?.itissues_name && tdetail?.ticket_reated_sub_issues
                                        ? `${tdetail.itissues_name} => ${tdetail.ticket_reated_sub_issues}`
                                        : tdetail?.itissues_name || tdetail?.ticket_reated_sub_issues || ""}
                                </span>
                                {tdetail?.names?.map((name, index) => (
                                    <span className="tagnames" key={index}>{name}</span>
                                ))}
                            </div>
                        </div>
                        <div
                            className="timeline-description mb-4" style={{ color: "#000" }}
                            dangerouslySetInnerHTML={{
                                __html: tdetail?.ticket_desc || "No Description Provided",
                            }}
                        />
                        <div className="timeline">
                            {isLoading ? (
                                <>
                                    {[...Array(5)].map((_, index) => (
                                        <div key={index}>
                                            {Array.from({ length: 3 }).map((_, idx) => (
                                                <Skeleton animation="wave" variant="text" />
                                            ))}
                                        </div>
                                    ))}
                                </>
                            ) : ticketreply.length ? (
                                ticketreply.map((reply, index) => (
                                    <div className="timeline-item d-flex align-items-start" key={index}>
                                        <div className="timeline-avatar">
                                            <div
                                                className="avatar-placeholder"
                                                style={{
                                                    backgroundColor: getBackgroundColor(reply.names || "Unknown"),
                                                }}
                                            >
                                                {(reply.names || "S").charAt(0).toUpperCase()}
                                            </div>
                                        </div>
                                        <div className="timeline-content-wrapper">
                                            <div className="timeline-content">
                                                <div className="d-flex justify-content-between">
                                                    <h5 className="timeline-title">{reply.names || "Unknown User"}</h5>
                                                    <div className="d-flex timeline-timestamp text-secondary" style={{ gap: "15px" }}>
                                                        <h5 className="timeline-title text-warning">{reply.ticket_reply_status || "Unknown User"}</h5>
                                                        {moment(reply.ticket_reply_created_at).format(
                                                            "MMM Do YYYY, h:mm:ss a"
                                                        ) || "Unknown Date"}
                                                    </div>
                                                </div>
                                                <div
                                                    className="timeline-description" style={{ color: "#000" }}
                                                    dangerouslySetInnerHTML={{
                                                        __html: reply.ticket_reply_desc || "No Description Provided",
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div>
                                    <span className="text-center">Data not found...</span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </ContentWrapper>
        </div>
    );
};
export default TicketDetails;
